import _ from 'lodash';
import find from 'lodash/find';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { checkAccess } from 'app/actions/app.actions';
import contactHelpers from 'contact/helpers/contact-helpers';
import helpers from 'app/app-helpers';
import { discardLotteryContactsChanges, fetchLotteryContacts, publishLotteryContactsChanges } from 'contact/actions/contact.actions';
import EditCategoryDialogController from './edit-category-dialog/edit-category-dialog-controller';
import editContactDialogTemplate from './edit-contact-dialog/edit-contact-dialog.html';
import EditContactDialogController from './edit-contact-dialog/edit-contact-dialog-controller';
import editCategoryDialogTemplate from './edit-category-dialog/edit-category-dialog.html';
import manageContactTemplate from './manage-contact.html';

const mapStateToThisContactManagement = ({ session, config, contact }) => {
  const { locale } = session;
  const { locales, secondHandApproval } = config;
  const {
    lottery: { contactList },
  } = contact;

  return {
    locale,
    session,
    locales,
    secondHandApproval,
    contactList,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  checkAccess,
  fetchLotteryContacts,
  discardLotteryContactsChanges,
  publishLotteryContactsChanges,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'gettextCatalog', 'Notifications', 'Responsive')
class ContactManagementController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThisContactManagement, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.onLanguageSelect(this.locale);
    this.DIRTY_FORM = 'contactManagement';
    this.secondHandApprovalActive = this.checkAccess('contact.manage.approve');
    await this.fetchLotteryContacts();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  cancel() {
    return this.fetchLotteryContacts();
  }

  discardChanges() {
    this.setDirtyForm(this.DIRTY_FORM, false);
    return this.discardLotteryContactsChanges()
      .then(() => this.Notifications.alertSuccess(this.gettextCatalog.getString('Changes have been discarded')))
      .then(() => this.fetchLotteryContacts());
  }

  addCategory() {
    this.Notifications.showComplexDialog({
      template: editCategoryDialogTemplate,
      bindToController: true,
      controller: EditCategoryDialogController,
      resolve: {
        title: () => this.gettextCatalog.getString('New Category'),
        category: () => ({
          fields: {},
        }),
      },
    }).result.then((result) => {
      this.setDirtyForm(this.DIRTY_FORM, true);
      this.contactList.groups = contactHelpers.saveCategory(this.contactList.groups, result.category, false);
    });
  }

  addContact() {
    const exists = false;
    const contact = {
      id: helpers.generateUUID(),
      fields: {},
    };

    this.locales.map((locale) => {
      contact.fields[locale.code] = {
        phone: [],
        email: [],
        mapCoordinates: '',
      };
    });

    this.Notifications.showComplexDialog({
      template: editContactDialogTemplate,
      bindToController: true,
      controller: EditContactDialogController,
      resolve: {
        title: () => this.gettextCatalog.getString('New Contact'),
        contact: () => contact,
        categories: () => this.contactList.groups,
        exists: () => exists,
      },
    }).result.then((result) => {
      this.setDirtyForm(this.DIRTY_FORM, true);
      this.contactList.groups = contactHelpers.saveContact(this.contactList.groups, result.contact, exists, result.categoryChanged);
    });
  }

  publish() {
    if (!_.get(this, 'contactList.properties.phone')) {
      this.Notifications.alertWarning(
        this.gettextCatalog.getString('Default contact with valid phone number must be selected before publishing.')
      );
      return;
    }
    this.publishLotteryContactsChanges()
      .then(() => this.Notifications.alertSuccess(this.getSuccessText()))
      .then(() => this.fetchLotteryContacts())
      .then(() => this.setDirtyForm(this.DIRTY_FORM, false));
  }

  getSuccessText() {
    return this.secondHandApprovalActive || !this.secondHandApproval
      ? this.gettextCatalog.getString('Changes have been published')
      : this.gettextCatalog.getString('Changes have been submitted for approval');
  }

  // eslint-disable-next-line class-methods-use-this
  onAccept(sourceNodeScope, destNodesScope) {
    return !!find(destNodesScope.modelValue, ['name', sourceNodeScope.itemScope.modelValue.name]);
  }

  onDropped() {
    this.setDirtyForm(this.DIRTY_FORM, true);
  }

  onLanguageSelect(locale) {
    this.language = locale;
  }
}

export default class ManageContactComponent {
  constructor() {
    this.controller = ContactManagementController;
    this.template = manageContactTemplate;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/contact/components/manage-contact/manage-contact-component.js